import { useParams } from "react-router";
import {
  useRltWorkOrderShowQuery,
  useRltWorkOrderUpdateRepresentativeMutation,
  useRltWorkOrderUpdateServiceAddressMutation,
  useRltWorkOrderUpdateServiceContactMutation,
} from "@/services/backend/rlt/work-orders/api/work-order-api";
import { ServiceAddressCardWithMutation } from "@/services/backend/addresses/components/service-address-card";
import { ContactCardWithMutation } from "@/services/backend/contacts/components/contact-card";
import { RepresentativeCardWithMutation } from "@/services/backend/representatives/components/representative-card";
import { WorkOrder } from "@/services/backend/rlt/work-orders/types/work-order";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { WorkOrderInternalCommentInput } from "@/services/backend/rlt/work-orders/components/work-order-comment-input";
import { WorkOrderTeamLeaderInput } from "@/services/backend/rlt/work-orders/components/work-order-team-leader-input";
import { WorkOrderExecutingBranchSelect } from "@/services/backend/rlt/work-orders/components/work-order-executing-branch-select";
import { WorkOrderReferenceNumberInput } from "@/services/backend/rlt/work-orders/components/work-order-reference-number-input";
import { WorkOrderBeginDateInput } from "@/services/backend/rlt/work-orders/components/work-order-begin-date-input";
import { WorkOrderEndDateInput } from "@/services/backend/rlt/work-orders/components/work-order-end-date-input";
import { ConnectDocumentDataCard } from "@/services/backend/connect/components/connect-document-data-card";
import { GSMServiceKind } from "@/services/backend/services/types/kinds";
import { GSMDocumentKind } from "@/services/backend/documents/types/kind";
import { WorkOrderCustomerReferenceInput } from "@/services/backend/rlt/work-orders/components/work-order-customer-reference-input";
import { isImmutable } from "@/services/backend/documents/lib/document-state";

export function WorkOrderCompletionBaseDataRoute() {
  const { workOrderId } = useParams();
  const { data: workOrder } = useRltWorkOrderShowQuery({ id: workOrderId! });

  return (
    <div className="grid gap-2">
      <PlanningBaseData workOrder={workOrder!} />
      <ConnectDocumentDataCard
        serviceKind={GSMServiceKind.RLT}
        documentKind={GSMDocumentKind.WorkOrder}
        documentId={workOrderId!}
      />
      <ServiceAddressCardWithMutation
        id={workOrder!.id}
        address={workOrder!.serviceAddress}
        mutation={useRltWorkOrderUpdateServiceAddressMutation}
        disabled={isImmutable(workOrder!)}
      />
      <div className="md:grid md:grid-cols-2 md:gap-2">
        <ContactCardWithMutation
          fieldName="serviceContact"
          id={workOrder!.id}
          contact={workOrder!.serviceContact}
          mutation={useRltWorkOrderUpdateServiceContactMutation}
          disabled={isImmutable(workOrder!)}
        />
        <RepresentativeCardWithMutation
          id={workOrder!.id}
          representative={workOrder!.representative}
          mutation={useRltWorkOrderUpdateRepresentativeMutation}
          disabled={isImmutable(workOrder!)}
        />
      </div>
    </div>
  );
}

export function PlanningBaseData({ workOrder }: { workOrder: WorkOrder }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Arbeitsschein")}</CardTitle>
      </CardHeader>
      <CardContent className="grid gap-4">
        <WorkOrderReferenceNumberInput workOrder={workOrder} />
        <div className="grid gap-4 lg:grid-cols-2">
          <WorkOrderBeginDateInput
            workOrder={workOrder}
            disabled={isImmutable(workOrder)}
          />
          <WorkOrderEndDateInput
            workOrder={workOrder}
            disabled={isImmutable(workOrder)}
          />
          <WorkOrderExecutingBranchSelect
            workOrder={workOrder}
            disabled={isImmutable(workOrder)}
          />
          <WorkOrderTeamLeaderInput
            workOrder={workOrder}
            disabled={isImmutable(workOrder)}
          />
          <WorkOrderCustomerReferenceInput
            workOrder={workOrder}
            disabled={isImmutable(workOrder)}
          />
        </div>
        <WorkOrderInternalCommentInput
          workOrder={workOrder}
          disabled={isImmutable(workOrder)}
        />
      </CardContent>
    </Card>
  );
}
